import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
  signal,
} from '@angular/core';
import { FormControlDynamicComponent } from '@form';
import { FormControl } from '@angular/forms';
import { RadioOption } from '@form';

@Component({
  selector: 'ui-chart-selector-form',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormControlDynamicComponent],
  template: `
    @if (radioControl() && options()) {
      <div
        class="flex flex-row flex-wrap w-full bg-neutral-3 px-4 py-2 rounded-lg"
      >
        <form-control
          [control]="radioControl()"
          [label]="'Label'"
          [type]="'radio'"
          [value]="optionSelected() || null"
          [typeInputs]="{ options: options() }"
        />
      </div>
    }
  `,
})
export class ChartSelectorFormComponent {
  protected readonly radioControl = signal(new FormControl<string>(''));
  optionSelected = input<string>();
  onOptionSelected = output<string>();
  options = input.required<RadioOption[]>();

  ngOnInit() {
    this.radioControl().valueChanges.subscribe( (value) => {
      this.onOptionSelected.emit(value!);
    });
  }
}
